import React from 'react';
import api from 'api';
import moment from 'moment';
import { Spinner, Modal } from 'hyperdb-utils';
import { AppLink } from '../../../routing/containers';

class DeparturesTable extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    let url = '/next-departures';
    if (this.props.fullListing) url += '?days=30';
    this.props.api.reservation.getData({
      url,
      propName: !this.props.fullListing ? 'nextDepartures' : 'fullDepartures',
    });
  }
  componentWillUnmount() {
    this.props.api.reservation.setData({ showMoreNextDepartures: false });
  }
  render() {
    const nextDepartures = !this.props.fullListing ? this.props.nextDepartures : this.props.fullDepartures;
    const today = moment();
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) return null;
    return (
      <div className="box">
        <Spinner show={ this.props.loading } />
        <table className="table table-bordered table-striped details">
          <thead>
            <tr className="info">
              <th colSpan="7">
                Next departures &nbsp;
                {
                  this.props.fullListing
                    ? null
                    : <span className="btn btn-primary btn-xs" onClick={ this.toggleModalFullListing.bind(this, true) }>See more</span>
                }
              </th>
            </tr>
            <tr>
              <th>Reference</th>
              <th>Customer</th>
              <th>Departure</th>
              <th>Property</th>
              <th>Transport</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              (nextDepartures || []).map((reservation, i) => {
                return (
                  <tr key={ i }>
                    <td>
                    {
                      currentUser.group.name === 'cleaning_staff'
                        ? reservation.reference
                        : <AppLink to={ `/daily-rental/reservations/${reservation.id}` }>
                            { reservation.reference }
                          </AppLink>
                    }
                    </td>
                    <td>{ reservation.customer.name }</td>
                    <td style={ moment(reservation.departure_date).isSame(today, 'day') ? { fontWeight: 'bold' } : {} }>
                      { moment(reservation.departure_date).format('DD/MM/YYYY') } { (reservation.departure_time || '').slice(0, -3) }
                    </td>
                    <td>{ reservation.property.name }</td>
                    <td>{ reservation.departure_transport }</td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
        {
          !this.props.fullListing && this.props.showMoreNextDepartures
            ? <Modal title="Next departures" onClose={ this.toggleModalFullListing.bind(this, false) }>
                <DeparturesTable { ...this.props } fullListing={ true } />
              </Modal>
            : null
        }
      </div>
    );
  }
  toggleModalFullListing(bool) {
    this.props.api.reservation.setData({ showMoreNextDepartures: bool });
  }
}

export default api.connect(DeparturesTable, 'reservation');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/arrivals-departures/containers/DeparturesTable.jsx